import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { arrayOf, shape, string } from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { ProjectShoppingImporter } from './project-shopping/ProjectShoppingImporter';
import { useProjectShopping } from './project-shopping/utils/useProjectShopping';

// We'll need to expand upon this wrapper to render project shopping in a harmony drawer for the PIP/PLP entry points
const ProjectShoppingWrapper = ({
  breadcrumbs,
  channel,
  itemId,
  projectId
}) => {
  const { showPortal, portalNode } = useProjectShopping(projectId);

  const [addedNValues, setAddedNValues] = useState([]);
  const [selectedItemId, setSelectedItemId] = useState();

  useEffect(() => {
    window.LIFE_CYCLE_EVENT_BUS.on('cart.add-to-cart', (cartData) => {
      setSelectedItemId(cartData?.output?.cartReqParams?.itemId);
    });
  }, []);

  if (!showPortal || !portalNode) {
    return null;
  }

  return createPortal(
    <QueryProvider cacheKey={`project-shopping-${channel}`}>
      <ProjectShoppingImporter
        addedNValues={addedNValues}
        breadcrumbs={breadcrumbs}
        itemId={itemId}
        projectId={projectId}
        selectedItemId={selectedItemId}
        setAddedNValues={setAddedNValues}
      />
    </QueryProvider>,
    portalNode
  );
};

ProjectShoppingWrapper.displayName = 'ProjectShoppingWrapper';

ProjectShoppingWrapper.propTypes = {
  breadcrumbs: arrayOf(shape({
    label: string,
    url: string,
    browseUrl: string,
    creativeIconUrl: string,
    deselectUrl: string,
    dimensionName: string,
    refinementKey: string
  })),
  channel: string,
  itemId: string,
  projectId: string,
};

ProjectShoppingWrapper.defaultProps = {
  breadcrumbs: [],
  channel: 'desktop',
  itemId: null,
  projectId: null,
};

export { ProjectShoppingWrapper };
